module.exports = __webpack_public_path__ + "static/media/profile-add.6eb7521b.svg";